import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/DSV_Logo.svg";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  const isActive = (path) => pathname === path;

  const links = [
    { name: "ABOUT US", path: "/aboutus" },
    { name: "SERVICES", path: "/services" },
    { name: "PORTFOLIO", path: "/portfolio" },
  ];

  return (
    <header className="fixed top-0 left-0 w-full z-50 bg-gradient-to-b from-ink/95 via-ink/85 to-transparent backdrop-blur-sm">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between py-5">
        {/* Brand */}
        <Link to="/" className="flex items-center gap-3 group">
          <img src={logo} alt="" className="h-8 w-auto" />
          <span className="font-display text-[21px] tracking-[0.22em] text-paper leading-none pt-1">
            DEEP-C VISION
          </span>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-10">
          {links.map(({ name, path }) => (
            <Link
              key={path}
              to={path}
              className={`font-mono text-[11px] tracking-[0.22em] transition-colors duration-200 ${
                isActive(path)
                  ? "text-brand-cyan"
                  : "text-muted hover:text-paper"
              }`}
            >
              {name}
            </Link>
          ))}
          <Link
            to="/contact"
            className="rounded-full bg-brand px-6 py-2.5 text-[13px] font-medium text-white
                       shadow-glow transition-all duration-200 hover:-translate-y-0.5 hover:shadow-glow-lg"
          >
            Get in touch
          </Link>
        </nav>

        {/* Mobile toggle */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
          className="md:hidden text-paper p-3 -mr-2 min-w-[44px] min-h-[44px] flex items-center justify-center rounded-lg hover:bg-white/5 active:bg-white/10 transition-colors"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={1.8}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d={menuOpen ? "M6 18L18 6M6 6l12 12" : "M4 7h16M4 12h16M4 17h16"}
            />
          </svg>
        </button>
      </div>

      {/* Mobile menu modal drawer & scrim */}
      {menuOpen && (
        <>
          <div
            className="fixed inset-0 top-[73px] bg-black/60 backdrop-blur-md z-40 md:hidden animate-fadeUp"
            onClick={() => setMenuOpen(false)}
            aria-hidden="true"
          />
          <nav className="relative z-50 md:hidden bg-ink border-t border-ink-line px-6 py-5 flex flex-col gap-1 shadow-2xl">
            {[...links, { name: "CONTACT US", path: "/contact" }].map(
              ({ name, path }) => (
                <Link
                  key={path}
                  to={path}
                  onClick={() => setMenuOpen(false)}
                  className={`font-mono text-[11px] tracking-[0.22em] py-3.5 px-2 min-h-[44px] flex items-center transition-colors rounded-md ${
                    isActive(path)
                      ? "text-brand-cyan font-medium"
                      : "text-muted hover:text-paper"
                  }`}
                >
                  {name}
                </Link>
              )
            )}
          </nav>
        </>
      )}
    </header>
  );
};

export default Navbar;
